import { render, staticRenderFns } from "./VisitorApprovalModal.vue?vue&type=template&id=18f88ba2&"
import script from "./VisitorApprovalModal.vue?vue&type=script&lang=js&"
export * from "./VisitorApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports